module.exports = __webpack_public_path__ + "img/feedback_correct_light.b44948e9.png";